import { AxiosRequestConfig } from 'axios'

export interface ManualCampaignsParams {
  startDate: string
  endDate: string
}

export interface ManualCampaign {
  pushTitle?: string | null
  title?: string | null
  pushesSent: number
  pushesReceived: number
  walkthrough: number
  benefitsRedeemed: number
}

export interface ManualCampaignsResponse {
  data: ManualCampaign[]
}

const getManualCampaigns = (params: ManualCampaignsParams): AxiosRequestConfig => ({
  url: '/dashboard/manual-campaigns',
  method: 'GET',
  params,
})

export { getManualCampaigns }
